import { useDownload } from '@/hooks/useDownload';
import {
  GetImportHistoryErrorsCsvDownloadsCsvEncoding,
  useGetImportHistoryErrorsCsvDownloads,
  useGetImportHistoryErrorsSuspense,
} from 'ap-openapi';
import { useCallback, useMemo } from 'react';

export const useErrorDetailDrawerContent = (id: string) => {
  const { data } = useGetImportHistoryErrorsSuspense(id);

  const { mutateAsync: getImportHistoryErrorsDownload } =
    useGetImportHistoryErrorsCsvDownloads({
      mutation: { throwOnError: false, retry: false },
    });

  const submittedAt = data?.data?.submitted_at;
  const finishedAt = data?.data?.completed_at;
  const errors = data?.data?.import_error_messages;

  const download = useDownload();

  const downloadFile = useCallback(
    async (encoding: GetImportHistoryErrorsCsvDownloadsCsvEncoding) => {
      const { data } = await getImportHistoryErrorsDownload({
        id: id,
        params: { csv_encoding: encoding },
      });
      download({ value: data, fileName: 'import_history_errors.csv' });
    },
    [getImportHistoryErrorsDownload, id, download]
  );

  return useMemo(
    () => ({
      submittedAt,
      finishedAt,
      errors,
      downloadFile,
    }),
    [submittedAt, finishedAt, errors, downloadFile]
  );
};
